"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var GalleryComponent_1 = require("./GalleryComponent");
var PreloadableGalleryComponent = /** @class */ (function (_super) {
    __extends(PreloadableGalleryComponent, _super);
    function PreloadableGalleryComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = __assign({}, _this.props);
        _this.containerRef = React.createRef();
        _this.galleryRef = React.createRef();
        _this.loaded = false;
        return _this;
    }
    PreloadableGalleryComponent.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('resize', function () {
            _this.setContainerSize();
        });
    };
    PreloadableGalleryComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.slideIndex !== this.state.slideIndex) {
            this.setState({
                slideIndex: nextProps.slideIndex
            });
        }
    };
    PreloadableGalleryComponent.prototype.setContainerSize = function () {
        var container = this.containerRef.current;
        this.setState({
            width: container.offsetWidth,
            height: container.offsetHeight
        });
    };
    PreloadableGalleryComponent.prototype.render = function () {
        var _this = this;
        var arrowStyle = { textShadow: '0 0 3px #333', fontSize: '20pt', color: '#fff' };
        var containerStyle = { width: '100%', height: '100%', position: 'relative' };
        var next = function () {
            _this.galleryRef.current.next();
        };
        var prev = function () {
            _this.galleryRef.current.prev();
        };
        var onItemClick = function (item) {
            if (_this.props.onItemClick)
                _this.props.onItemClick(item);
        };
        var onSlideIndexChanged = function (slideIndex) {
            if (_this.props.onSlideIndexChanged)
                _this.props.onSlideIndexChanged(slideIndex);
        };
        var onLoaded = function () {
            if (_this.loaded)
                return;
            _this.loaded = true;
            _this.setContainerSize();
        };
        return (React.createElement("div", { ref: this.containerRef, className: "gallery-controlled", style: containerStyle },
            React.createElement(GalleryComponent_1["default"], __assign({ ref: this.galleryRef }, this.state, { onItemClick: onItemClick, onSlideIndexChanged: onSlideIndexChanged, onLoaded: onLoaded })),
            React.createElement("button", { onClick: prev, className: "c-gallerycomponent c-gallerycomponent__left" },
                React.createElement("span", { style: arrowStyle, className: "fal fa-chevron-left" })),
            React.createElement("button", { onClick: next, className: "c-gallerycomponent c-gallerycomponent__right" },
                React.createElement("span", { style: arrowStyle, className: "fal fa-chevron-right" }))));
    };
    return PreloadableGalleryComponent;
}(React.Component));
exports["default"] = PreloadableGalleryComponent;
